'use client';

import { useChat } from '../context/ChatContext';
import CrossMark from '@src/assets/svg/crossMark';

export default function ChatHeader() {
  const { closeChat, messages, resetMessages, isStreaming } = useChat();

  const hasMessages = !!messages?.length;

  return (
    <div
      className="
        flex
        justify-between
        items-center
        px-[16px]
        pt-[16px]
        pb-[16px]
        pe-[20px]
        self-stretch
      "
    >
      {/* Left Side */}
      {hasMessages ? (
        <button
          onClick={resetMessages}
          disabled={isStreaming}
          className={`
            flex
            items-center
            gap-[8px]
            rounded-full
            p-[12px]
            bg-[var(--Color-Themes-Blue-100,#F0F7FF)]
            text-[var(--Color-Themes-Blue-600,#52AEFF)]
            text-[14px]
            font-medium
            tracking-[-0.14px]
            font-[Geist]
            leading-none
            transition
            ${
              isStreaming
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:opacity-90 active:scale-95'
            }
          `}
        >
          <img
            src="/rotate-clockwise.svg"
            alt="Clear chat"
            className="h-4 w-4"
          />
          Clear Chat
        </button>
      ) : (
        <div /> /* Placeholder to keep header balanced when no messages */
      )}

      {/* Right Side */}
      <button
        onClick={closeChat}
        disabled={isStreaming}
        className={`
        flex
        w-[36px]
        h-[37px]
        items-center
        justify-center
        gap-[10px]
        rounded-full
        text-gray-400
        transition
        ${
          isStreaming
            ? 'opacity-30 cursor-not-allowed'
            : 'opacity-50 hover:opacity-80'
        }
  `}
        aria-label="Close chat"
      >
        <CrossMark />
      </button>
    </div>
  );
}
